import { render, staticRenderFns } from "./AddMachines.vue?vue&type=template&id=156a2aca"
import script from "./AddMachines.vue?vue&type=script&lang=js"
export * from "./AddMachines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports